import React, { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import SelectInput from '../InputComponent/SelectInput';
import TextInput from '../InputComponent/TextInput';

const MembershipInfoStep = ({ data, onNext, onBack, trainers, plans, isEdit }) => {
    const [formData, setFormData] = useState(data?.membership);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "assignedTrainer") {
            const trainer = trainers.find(t => t.id == value);

            setFormData(prev => ({
                ...prev,
                [name]: value,
                trainer_name: trainer ? trainer.name : null
            }));

            return;
        }

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const getdateCalculation = () => {
        const selectedPlan = plans.find(t => t.id == formData.planId);
        if (!selectedPlan || selectedPlan?.access_type == 'session') return;

        // Safe duration parsing
        const rawDuration = selectedPlan.duration;
        const duration = Number(rawDuration);

        if (!rawDuration || isNaN(duration) || duration <= 0) {
            console.warn("Invalid duration:", rawDuration);
            return;
        }

        // Safe start date parsing
        const rawStart = formData.startDate;
        const startDate = new Date(rawStart);

        if (!rawStart || isNaN(startDate.getTime())) {
            console.warn("Invalid start date:", rawStart);
            return;
        }
        setFormData((prev) => ({ ...prev, endDate: endDate.toISOString().slice(0, 10) }))
        // Add months safely
        const endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + duration);
        console.log("plan:", selectedPlan);

        console.log("Start:", startDate.toISOString().slice(0, 10));
        console.log("End:", endDate.toISOString().slice(0, 10));
    };

    useEffect(() => {
        getdateCalculation()
    }, [formData.planId, formData.startDate])


    const handleContinue = () => {
        console.log(formData?.userStatus == 'active');
        console.log(!formData.planId);
        console.log(formData.assignedTrainer != null);
        if (formData?.userStatus == 'active' && (!formData.planId || !formData.assignedTrainer)) {
            toast.error('Please select a plan and Trainer for active member');
            return;
        }

        onNext({ membership: formData });
    };

    return (
        <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">3. Membership Info</h3>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                <SelectInput label={"Membership Plan"} name="planId" value={formData.planId} onChange={handleChange} isRequired={formData.userStatus === 'active'}>
                    <option value="" disabled>Select a plan</option>
                    {plans.filter(p => p.status === 'active').map(p => (
                        <option key={p.id} value={p.id}>{p.name} - {p.price.toFixed(3)} OMR</option>
                    ))}
                </SelectInput>
                <TextInput   label={"Start Date"}  type="date" name="startDate" value={formData.startDate} onChange={handleChange} />
                <SelectInput label={"Assigned Trainer"} name="assignedTrainer" value={formData.assignedTrainer ?? ''} onChange={handleChange} isRequired={formData.userStatus === 'active'}>
                    <option>Select Trainer -</option>
                    {trainers.map(trainer => (
                        <option key={trainer.id} value={trainer.id}>{trainer.name}</option>
                    ))}
                </SelectInput>
                <SelectInput label={"User Status "} disabled={data?.id == null} name="userStatus" value={formData.userStatus} onChange={handleChange}>
                    <option value={'inactive'}>Inactive</option>
                    <option value={'active'}>Active</option>
                </SelectInput>
            </div>
            <div className="pt-4 flex justify-between">
                <button onClick={onBack} className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Back</button>
                <button onClick={handleContinue} className="px-6 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">Save & Continue</button>
            </div>
        </div>
    );
};

export default MembershipInfoStep;
